<template>
  <div class='company' ref='listWrapper'>
    <div class='scroll-content'>
      <j-pull v-if="resultList.length" :refreshFunc="refreshFunc" :loadMore="loadMore">
        <ul class="ui-list ui-list-text" ref='listUl'>
          <li class="ui-border-t" v-for="list in resultList" :key="list">
            <div class="ui-list-info">
              <h4 class="ui-nowrap">{{ list.enterpriseName }}</h4>
            </div>
            <div class="ui-new" v-if="list.hasNew"></div>
          </li>
        </ul>
      </j-pull>
    </div>
  </div>
</template>

<script>
import api from '@/script/util'
import '@/style/frozen.css'
import '@/style/base.css'
import JPull from '@/util/JPull'

export default {
  name: 'contactus',
  data () {
    return {
      resultList: []
    }
  },
  components: {
    'j-pull': JPull
  },
  created: function () {
    this.GetData()
  },
  methods: {
    // 获取数据
    GetData (pageIndex, pageSize, cb) {
      let params = {
        townId: api.getVal('townId'),
        pageSize: pageSize || 15,
        curPage: pageIndex || 1
      }
      api.GetCompanyList(params)
        .then(res => {
          res.resultList.forEach(function (el) {
            el.hasNew = new Date(el.intime).getTime() > (new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
          }, this)
          this.resultList = res.resultList
        })
      cb && cb(true)
    },
    refreshFunc: function (pageIndex, pageSize, cb) {
      this.GetData(pageIndex, pageSize, cb)
    },
    loadMore: function (pageIndex, pageSize, cb) {
      let _this_ = this
      let postData = {
        curPage: pageIndex,
        pageSize: pageSize,
        townId: api.getVal('townId')
      }
      api.GetCompanyList(postData)
        .then(res => {
          if (res.resultList.length > 0) {
            res.resultList.forEach(function (el) {
              el.hasNew = new Date(el.intime).getTime() > (new Date().getTime() - 30 * 24 * 60 * 60 * 1000)
            }, this)
            res.resultList.forEach(function (el) {
              this.resultList.push(el)
            }, this)
          } else {
            let hasMore = false
            _this_.$nextTick(() => {
              setTimeout(function () {
                cb(hasMore)
              }, 10)
            })
          }
          let hasMore = res.pageInfo.hasMore
          _this_.$nextTick(() => {
            setTimeout(function () {
              cb(hasMore)
            }, 10)
          })
        })
    }
  }
}
</script>


<style scoped>
.company {
  position: absolute;
  height: 100%;
  width: 100%;
}
.scroll-content {
  position: absolute;
  height: 100%;
  width: 100%;
  height: 100%;
}
.company .ui-list{
  /*position: relative;*/
  background-color: #ebebeb;
   /*min-height: 100%;*/
}
.company .ui-list>li {
  height: 2.2rem;
  padding: 0 .75rem!important;
  background-color: #fff;
}

.ui-new {
  background-image: url('../assets/image/new.png');
  background-size: 1.5rem .75rem;
  width: 1.5rem;
  height: .75rem;
}
.bottom-tip{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// company.vue?4f5f0f5b